import { takeLatest } from 'redux-saga/effects';
import {
  getSalaryDeductionListSuccess, getSalaryDeductionListFail,
  getSalaryDeductionDetailsSuccess, getSalaryDeductionDetailsFail
} from './salaryDeductionState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/finance/salary-deductions');
const redirectData = {route:'/console/salary-deductions', mode: 'list', recordId:0 };
const modelName = 'Salary Deduction';
const modelId = 'sdd_id';

function* getSalaryDeductionList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getSalaryDeductionListSuccess, 
		getSalaryDeductionListFail,
		null, null, LOADING_MSG);
}

function* getSalaryDeductionDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getSalaryDeductionDetailsSuccess, 
		getSalaryDeductionDetailsFail,
		null, null, LOADING_MSG);		
}

function* doSalaryDeductionCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getSalaryDeductionDetailsSuccess, 
		getSalaryDeductionDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'}, SAVING_MSG);
}

function* doSalaryDeductionUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getSalaryDeductionDetailsSuccess, 
		getSalaryDeductionDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: 'reload'}, UPDATING_MSG);	
}

function* doSalaryDeductionDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getSalaryDeductionDetailsSuccess, 
		getSalaryDeductionDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* salaryDeductionSaga() {
  yield takeLatest('salaryDeduction/getSalaryDeductionList', getSalaryDeductionList);
  yield takeLatest('salaryDeduction/getSalaryDeductionDetails', getSalaryDeductionDetails);
  yield takeLatest('salaryDeduction/doSalaryDeductionCreate', doSalaryDeductionCreate);
  yield takeLatest('salaryDeduction/doSalaryDeductionUpdate', doSalaryDeductionUpdate);
  yield takeLatest('salaryDeduction/doSalaryDeductionDelete', doSalaryDeductionDelete);  
}

export default salaryDeductionSaga;
